export default "__VITE_ASSET__BHzRaK1L__"